'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var IconButton = (_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(IconButton, _React$Component);

  function IconButton() {
    (0, _classCallCheck3.default)(this, IconButton);
    return (0, _possibleConstructorReturn3.default)(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(IconButton, [{
    key: 'onPress',
    value: function onPress() {
      if (this.props.disabled) return;
      if (this.props.loading) return;
      this.props.onPress();
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var classes = [];
      if (this.props.disabled) classes.push('os_iconButton_disabled');
      if (this.props.loading) classes.push('os_iconButton_loading');
      if (!this.props.disabled && !this.props.loading) classes.push('os_iconButton');
      return classes.join(' ');
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      return _react2.default.createElement('span', {
        className: this.getClassName(),
        onClick: this.onPress,
        style: this.props.style
      }, _react2.default.createElement(this.props.icon, {
        size: this.props.size
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.tooltip) {
        return _react2.default.createElement(_Tooltip2.default, {
          content: this.props.tooltip
        }, this.renderButton());
      } else {
        return this.renderButton();
      }
    }
  }]);
  return IconButton;
}(_react2.default.Component), _class2.propTypes = {
  icon: _propTypes2.default.func,
  size: _propTypes2.default.number,
  onPress: _propTypes2.default.func,
  style: _propTypes2.default.object,
  tooltip: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  loading: _propTypes2.default.bool
}, _class2.defaultProps = {
  size: 24,
  onPress: function onPress() {},
  style: {}
}, _temp), _applyDecoratedDescriptor(_class.prototype, 'onPress', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onPress'), _class.prototype), _class);
exports.default = IconButton;